import React from 'react'
import '../Footer/Footer.css'
import './action.css'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import { Config } from '../../Config'
import AuthenticationService from '../Security/AuthenticationService'
import { CommonConstants } from '../../Constants'
import _ from 'underscore'
import Api from '../../Api'
// import { bindActionCreators } from 'redux'
// import { connect } from 'react-redux'
import { unRegisterSystem, unRegisterSystemSetSettings, unRegisterZoomSystem } from '../../actions/actions'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
const js2xmlparser = require('js2xmlparser')

class UnregisterSystem extends React.Component {
  constructor () {
    super()
    this.state = {
      language: languageSettings.getCurrentLanguage()
    }
    this.api = new Api()
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.unRegisterSystemPopup = this.unRegisterSystemPopup.bind(this)
    this.unRegisterSystem = this.unRegisterSystem.bind(this)
    this.xmlCIBSettings = this.xmlCIBSettings.bind(this)
  }

  // Page Reload

  pageRefresh () {
    window.location.reload()
  }

  // unRegisterSystemPopup
  unRegisterSystemPopup () {
    if (!this.props.display) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className='popup'>
              <p className='popup_Title'>Confirmation Required</p>
              <p className='popup_message'>{t[this.state.language]['CIBSystem_Remove_Popup_Message']}</p>
              <span className='popup_warning warningMsg'><strong className='warning'>WARNING:</strong> This action cannot be undone!</span>
              <div className='popup_buttons'>
                <div className='buttonSet' />
                <div className='popup-button'>
                  <button className='popup_buttons buttons' onClick={() => {
                    this.unRegisterSystem()
                    onClose()
                  }}>Confirm</button>
                  <button className='popup_buttons buttons' onClick={() => { onClose() }}>Close</button>
                </div>
              </div>
            </div>
          )
        }
      })
    }
  }

  // DTDS OutPut popup

  dtdsOutputPopupSuccess () {
    confirmAlert({
      customUI: ({ title, message, onClose }) => {
        return (
          <div className='popup modal-dialog'>
            <p className='popup_Title'>Confirmation Required</p>
            <p className='popup_message successMsg'>Success! The requested system has been removed</p>
            <div className='popup_buttons'>
              <div className='buttonSet' />
              <div className='popup-button'>
                <button className='popup_buttons buttons' onClick={() => {
                  this.pageRefresh()
                  onClose()
                }}>Close</button>
              </div>
            </div>
          </div>
        )
      }
    })
  }

  // DTDS OutPut Error popup
  dtdsOutputPopupError (error) {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='popup'>
            <p className='popup_Title'>Confirmation Required</p>
            <p className='popup_message warning'> Error! Something went wrong, please try your request again.</p>
            <p className='popup_message'>{error}</p>
            <div className='popup_buttons'>
              <div className='buttonSet' />
              <div className='popup-button'>
                <button className='popup_buttons buttons' onClick={() => {
                  onClose()
                }}>Close</button>
              </div>
            </div>
          </div>
        )
      }
    })
  }

  // Zoom Device Remove Error
  zoomDevicePopupError () {
    confirmAlert({
      customUI: ({ title, message, onClose }) => {
        return (
          <div className='popup'>
            <p className='popup_message'>Confirmation Required</p>
            <p className='popup_message warning'> Error! Something went wrong, please try your request again. </p>
            <div className='popup_buttons'>
              <div className='buttonSet' />
              <div className='popup-button'>
                <button className='popup_buttons buttons' onClick={() => {
                  this.pageRefresh()
                  onClose()
                }}>Close</button>
              </div>
            </div>
          </div>
        )
      }
    })
  }

  // DTDS call
  unRegisterSystem () {
    if (this.props.deviceName === 'CIB') {
      let cibXML = []
      if (this.props.CIBSystem.length > 0) {
        cibXML = this.xmlCIBSettings(this.props.CIBSystem)
      }
      if (this.props.deviceID) {
        try {
          _.map(this.props.deviceID, (obj) => {
            let DeviceId = obj.device_ID
            unRegisterSystem(DeviceId, (result) => {
              if (result.status) {
                _.map(cibXML, (xmlData) => {
                  xmlData = xmlData.toString()
                  unRegisterSystemSetSettings(DeviceId, xmlData, (Output) => {
                    if (Output.status) {
                      // Success message
                      this.dtdsOutputPopupSuccess()
                    } else {
                      this.dtdsOutputPopupError(Output.ErrorMessage)
                    }
                  })
                })
              } else {
                this.dtdsOutputPopupError(result.ErrorMessage)
              }
            })
          })
        } catch (e) {
          this.dtdsOutputPopupError(e)
        }
      }
    } else if (this.props.deviceName === 'Zoom') {
      // Call DTDS Service
      if (this.props.deviceID) {
        try {
          _.map(this.props.zoomSystem, (obj) => {
            // Check If deviceType ID equal to 1 means call DTDS Service to Remove
            if (obj.Device_DeviceType_ID === 1) {
              let ZoomDevice = {}
              ZoomDevice.deviceID = obj.Device_ID
              ZoomDevice.deviceUID = obj.Device_UID
              ZoomDevice.deviceVersion = obj.Device_MainVersion
              ZoomDevice.storeID = obj.Store_ID
              ZoomDevice.storeUID = this.props.deviceStoreUID
              // DTDS services
              unRegisterZoomSystem(ZoomDevice, (result) => {
                if (result.status) {
                  console.log('DTDS Services ZoomDevice Remove success')
                } else {
                  // this.dtdsOutputPopupError(result.ErrorMessage)
                  console.log('DTDS Services ZoomDevice Remove unsuccess')
                }
              })
            }
            // Call Unbind request to DB and remove store account details
            let zoomStoreDetails = {}
            zoomStoreDetails.DeviceUID = obj.Device_UID
            zoomStoreDetails.StoreID = obj.Store_ID
            let url = Config.apiBaseUrl + CommonConstants.apiUrls.removeZoomDevice
            this.api.postData(url, zoomStoreDetails, data => {
              if (data.status) {
                this.dtdsOutputPopupSuccess()
              } else if (!data.status) {
                this.zoomDevicePopupError()
              }
            })
          })
        } catch (e) {
          this.dtdsOutputPopupError(e)
        }
      }
    }
  }

  // CIB System setting XML creation

  xmlCIBSettings (systemDetails) {
    let cibXml = []
    let CIBsystemData = systemDetails
    CIBsystemData = CIBsystemData.filter(function (item) {
      return item.Device_Name !== 'EOS' && item.Device_Name !== 'ION'
    })
    _.map(CIBsystemData, (value) => {
      let cibSystem = {}
      cibSystem.Store_Number = value.Store_Number
      cibSystem.User_EmailAddress = this.props.userEmail
      cibSystem.Brand_Name = value.Brand_Name
      cibSystem.Timezone = value.Timezone
      cibXml.push(js2xmlparser.parse('xmlCIBSettings', cibSystem))
    })
    return cibXml
  }

  render () {
    const { language } = this.state
    return (
      <div>
        <a className='remove-system-device' onClick={this.unRegisterSystemPopup}>
          <span className={'remove-device-item ' + (this.props.display ? 'disable-remove-device' : '')}>{t[language].RemoveSystem}</span>
        </a>
      </div >
    )
  }
}

export default UnregisterSystem



// WEBPACK FOOTER //
// ./src/components/Actions/Unregistersystem.js